module.exports = __webpack_public_path__ + "img/DirectionsWalkOutlined.a2602370.svg";